import Cookie from 'js-cookie';
import {
  ELSURLHelper,
  ELSCommonConfig,
  ELSTokenHelper,
} from '@els/els-ui-common-react';
import {
  APP_LINK_COOKIE_EXPIRATION_DAYS,
  AppLinkCookie
} from '../constants/app-link-redirect.constants';
import { ServerConstants } from '../components/app/server.constants';
import { AppLinkCookies } from '../apis/eols-app-link/eols-app-link.dtos';

export const removeCookies = (): void => {
  const domain = ServerConstants[ELSCommonConfig.appProfile].cookiesDomain;
  Cookie.remove(AppLinkCookie.X_LINK_ID, { path: '/', domain });
  Cookie.remove(AppLinkCookie.X_TOKEN, { path: '/', domain });
};

export const pickCookies = (): AppLinkCookies => {

  const tokenFromUrl = ELSURLHelper.getParameterByName('token');
  const linkIdFromUrl = ELSURLHelper.getParameterByName('linkId');

  if (tokenFromUrl && linkIdFromUrl) {

    removeCookies();

    return {
      token: tokenFromUrl,
      linkId: linkIdFromUrl
    };
  }

  const token = Cookie.get(AppLinkCookie.X_TOKEN);
  const linkId = Cookie.get(AppLinkCookie.X_LINK_ID);

  removeCookies();

  return { token, linkId };
};

export const setAppLinkCookies = (linkId: string): void => {
  const currentToken = ELSTokenHelper.getToken();
  const domain = ServerConstants[ELSCommonConfig.appProfile].cookiesDomain;

  Cookie.set(AppLinkCookie.X_LINK_ID, linkId, {
    path: '/',
    domain,
    expires: APP_LINK_COOKIE_EXPIRATION_DAYS
  });
  Cookie.set(AppLinkCookie.X_TOKEN, currentToken, {
    path: '/',
    domain,
    expires: APP_LINK_COOKIE_EXPIRATION_DAYS
  });
};
